import React, { Component } from 'react';
import './info.scss';

import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'


class Rewards extends Component {
    state = {
        data: [
            "Select the Voucher from the list of Vouchers available. You will see the number of points you can redeem for each voucher. You must have at least that many reward points available in order to redeem them in exchange for the Voucher.",
            "Submit the Voucher request. Once you submit the request, our team will approve the same and order your voucher. You can check the status of your Voucher Request in the “Voucher Redeemed” section of your profile. Remember – it can take up to 3 working days to approve and deliver your voucher.",
            "Once approved, you will receive your e-Voucher with instructions to use it on your email. It would go to the email ID you have used to register on Countingwell. Physical vouchers are not sent. All vouchers are sent by email only."
        ],
        pointEarnData : [
            "You will earn 5 reward points on assigning a homework  , subject a maximum of 40 reward points per month for each section.",
            "You will earn 5 reward points on assigning a assessment  , subject a maximum of 10 reward points per month for each section.",
            "You will earn 2 reward points for each student completing assessment / homework.",
            "You will earn additional reward points for every subscription (annual) taken by students in your class."

        ]
    }

    componentDidMount() {
    }



    render() {
        return (
            <div className="redeem-info">
                <div className="abs-image">
                    <img alt="" className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div>
                <div className="row pt-4">
                    <div className="col text-right my-auto"><img alt="" className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.props.back} /></div>
                </div>
                <div className="">
                    <div className="title">{this.props.type === "EARN" ? "How to earn reward points?" : "How to redeem reward points?" }</div>
                </div>
                {this.props.type === "EARN" ? <div>
                    {
                        this.state.pointEarnData.map((item, index) => (
                            <div className="row pt-3">
                                <div className="col-1 text-right"><span className="sno">{index + 1}.</span></div>
                                <div className="col pl-0 text-color">{item}</div>

                            </div>
                        ))
                    }
                </div> 
                : 
                <div>
                    {
                        this.state.data.map((item, index) => (
                            <div className="row pt-3">
                                <div className="col-1 text-right"><span className="sno">{index + 1}.</span></div>
                                <div className="col pl-0 text-color">{item}</div>

                            </div>
                        ))
                    }
                </div>}
                <div className="pt-4">
                    <button className='cw-btn-md cw-btn-primary' onClick={this.props.back} data-tip={"Bulk Upload Students"}>
                        OK, GOT IT
                    </button>
                </div>

            </div>);
    }
}

export default Rewards;